import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

const ROLE = "role";
const CREATE = "create";
const UPDATE = "update";
const DELETE = "delete";
const GET = "get";
const GET_ALL = "getAll";
const GET_PAGINATED = "getPaginated";

const MUTATION_KEYS = {
  [CREATE]: [ROLE, CREATE],
  [UPDATE]: [ROLE, UPDATE],
  [DELETE]: [ROLE, DELETE],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(ROLE, {
  [GET]: (params: Parameters<Service[typeof GET]>[0]) => [params],
  [GET_ALL]: null,
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0]) => [params],
});

export { CREATE, DELETE, GET, GET_ALL, GET_PAGINATED, MUTATION_KEYS, QUERY_KEYS, UPDATE };
